module.exports = __webpack_public_path__ + "static/media/location.1aa13a0a.png";